import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import api from '@/axios';
import {
  GET_PURCHASE_ORDER_KEY,
  GET_PURCHASE_ORDER_LINES_KEY,
  GET_PURCHASE_ORDERS_KEY,
} from '@/keys';

export function useCreateProductionDeclaration(purchaseOrderId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await api.post<{ id: string }>(
        `/purchase-orders/${purchaseOrderId}/production-declaration`,
      );
      return response.data;
    },
    onError: async (error) => {
      if (isAxiosError(error) && error.response?.status === 409) {
        await queryClient.invalidateQueries({
          queryKey: [...GET_PURCHASE_ORDER_KEY, purchaseOrderId],
        });
      }
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...GET_PURCHASE_ORDER_KEY, purchaseOrderId],
        }),
        queryClient.invalidateQueries({ queryKey: GET_PURCHASE_ORDERS_KEY }),
        queryClient.invalidateQueries({
          queryKey: [...GET_PURCHASE_ORDER_LINES_KEY, purchaseOrderId],
        }),
      ]);
    },
  });
}
